import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { useParams } from 'src/routes/hooks';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { LoanAgreementDetailView } from 'src/sections/loan-agreement/view';

export default function LoanDetailPage() {
  const { id } = useParams();

  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title>Loan Agreement</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_LOAN_AGREEMENT,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <LoanAgreementDetailView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
